import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { Product } from '../../types/product';
import { ProductFragments } from '../../graphql/product.graphql';
import { useAppDispatch } from '../../ui/pages/store';
import { productSlice } from '../../providers/ProductProvider';

const productSubscription = gql`
  subscription productNotification($companyId: String!) {
    productNotification(companyId: $companyId) {
      companyId
      entities {
        ...Product
      }
      topic
      date
    }
  }
  ${ProductFragments.product}
`;

export class ProductNotificationResponse extends forNotification<Product>('productNotification') {}

export default function ProductNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: productNotification } = useSubscription<ProductNotificationResponse>(productSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleProductNotification = (notification?: ProductNotificationResponse) => {
    if (!notification?.productNotification) return;
    const productNotification = notification.productNotification;

    switch (productNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(productSlice.actions.add(productNotification.entities));
        break;

      case 'DELETE':
        dispatch(productSlice.actions.delete(productNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleProductNotification(productNotification);
  }, [productNotification]);

  return <></>;
}
